import { compose } from 'redux';

import { reduxForm } from 'redux-form';

import { withIntl } from 'HOC/withIntl';
import getDefaultLanguageRequiredFieldsErrors from 'utilities/getDefaultLanguageRequiredFieldsErrors';
import generateInitialLanguageValues from 'utilities/generateInitialLanguageValues';
import shouldSubmit from 'utilities/shouldSubmit';

import AddNewsForm from '../components/NewsForm';

import { addNewsRequest } from '../services/actions';
import { forms, requiredFields, localizableFields, defaultValues } from '../services/config';

const form = forms.addNewsForm;
const langInitialValues = generateInitialLanguageValues();

const validate = (values, { intl }) =>
    getDefaultLanguageRequiredFieldsErrors(values, requiredFields, intl.formatMessage({ id: 'error.required' }));

const onSubmit = (data, dispatch, { intl }) => {
    const confirmMessage = intl.formatMessage({ id: 'alert.submit.warn' });
    if (shouldSubmit(data, localizableFields, confirmMessage)) {
        dispatch(addNewsRequest(form, data));
    }
};

export default compose(
    withIntl,
    reduxForm({
        form,
        initialValues: {
            ...langInitialValues,
            ...defaultValues,
        },
        validate,
        onSubmit,
    }),
)(AddNewsForm);
